export default __webpack_public_path__ + "static/media/angle-right-svgrepo-com.b3842def.svg";